import type { AbstractControl } from '@angular/forms';
import { PctFormGroup } from './pct-form-group';
import { isNil } from '@pct-ts/typeguard';

/**
 * Recursively searches for the root `PctFormGroup` in the given control hierarchy.
 * It traverses upwards through the parent controls until it finds the root form group.
 *
 * @param {AbstractControl<unknown, unknown> | null} control - The starting control from which to search for the root form group.
 * If the control is `null`, an error will be thrown.
 * @return {PctFormGroup | undefined} The root `PctFormGroup` if found, otherwise `undefined`. If the root control is
 * not an instance of `PctFormGroup`, the search will return `undefined`.
 */
export function searchRootFormGroup(
  control: AbstractControl<unknown, unknown> | null,
): PctFormGroup | undefined {
  if (isNil(control)) {
    throw new Error('[searchRootFormGroup]: not found control');
  }
  if (!isNil(control?.parent)) {
    return searchRootFormGroup(control.parent);
  }
  if (!(control instanceof PctFormGroup)) {
    console.info('[searchRootFormGroup]: root must be a PCTFormGroup');
    return undefined;
  }
  return control;
}
